import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import axiosConfig from "../../axiosConfig";
import { makeStyles } from "@material-ui/core/styles";
import * as headers from "../../shared/language.json";
import { checkFormik } from "../../shared/checkFormikErrors";
import * as regEx from "../../shared/regularExpressions";
import Swal from "sweetalert2";
import EndUser from "./EndUser";
import "../Forms/Forms.css";
const useUserFormStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(0),
    width: "100%",
  },
}));
function AddEndUser() {
  const [Devices, setDevices] = useState([]);
  const [checkFormikErrors, setCheckFormikErrors] = useState(false);
  const [endUserData, setEndUserData] = useState();
  const [loading, setLoading] = useState(true);
  const [IsValidAddress, setIsValidAddress] = useState(false);
  const [openMap, setOpenMap] = useState(false);
  const [allMunicipalities, setMunicipalities] = useState([]);

  let history = useHistory();
  let savedData;

  useEffect(() => {
    const unusedDevices = axiosConfig.get("/Device/GetUnusedDevices");
    const municipalities = axiosConfig.get("/Municipality/All");

    Promise.all([unusedDevices, municipalities])
      .then((res) => {
        setDevices(res[0].data);
        setMunicipalities(res[1].data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const formik = useFormik({
    initialValues: {
      firstname: endUserData?.firstname ?? "",
      lastname: endUserData?.lastname ?? "",
      middlename: endUserData?.middlename ?? "",
      yearOfBirth: endUserData?.yearOfBirth ?? "",
      genderId: endUserData?.genderId ?? "",
      personOfContact: endUserData?.personOfContact ?? "",
      telephone: endUserData?.telephone ?? "",
      mobile: endUserData?.mobile ?? "",
      email: endUserData?.email ?? "",
      street: endUserData?.street ?? "",
      number: endUserData?.number ?? "",
      floor: endUserData?.floor ?? "",
      postalcode: endUserData?.postalcode ?? "",
      devices: Array.isArray(endUserData?.devices)
        ? endUserData.devices
        : endUserData?.devices
        ? [endUserData.devices]
        : [],
      area: endUserData?.area ?? "",
      latitude: endUserData?.latitude ?? 0,
      longitude: endUserData?.longitude ?? 0,
      municipalityId: endUserData?.municipalityId ?? "",
    },
    validationSchema: Yup.object({
      firstname: Yup.string()
        .required(headers.FORMIKERRORMESSAGES.REQUIRED)
        .matches(
          regEx.nameRegex,
          headers.FORMIKERRORMESSAGES.FIRSTLETTERCAPITAL
        )
        .matches(regEx.lettersOnly, headers.FORMIKERRORMESSAGES.LETTERSONLY)
        .min(4, headers.FORMIKERRORMESSAGES.ATLEASTFOURCHARACTERS)
        .max(30, headers.FORMIKERRORMESSAGES.THIRTYCHARACTERSMAX),
      lastname: Yup.string()
        .required(headers.FORMIKERRORMESSAGES.REQUIRED)
        .matches(
          regEx.nameRegex,
          headers.FORMIKERRORMESSAGES.FIRSTLETTERCAPITAL
        )
        .matches(regEx.lettersOnly, headers.FORMIKERRORMESSAGES.LETTERSONLY)
        .min(4, headers.FORMIKERRORMESSAGES.ATLEASTFOURCHARACTERS)
        .max(30, headers.FORMIKERRORMESSAGES.THIRTYCHARACTERSMAX),
      middlename: Yup.string()
        .required(headers.FORMIKERRORMESSAGES.REQUIRED)
        .matches(
          regEx.nameRegex,
          headers.FORMIKERRORMESSAGES.FIRSTLETTERCAPITAL
        )
        .matches(regEx.lettersOnly, headers.FORMIKERRORMESSAGES.LETTERSONLY)
        .min(4, headers.FORMIKERRORMESSAGES.ATLEASTFOURCHARACTERS)
        .max(30, headers.FORMIKERRORMESSAGES.THIRTYCHARACTERSMAX),
      genderId: Yup.string().required(headers.FORMIKERRORMESSAGES.REQUIRED),
      personOfContact: Yup.string()
        .required(headers.FORMIKERRORMESSAGES.REQUIRED)
        .matches(
          regEx.nameRegex,
          headers.FORMIKERRORMESSAGES.FIRSTLETTERCAPITAL
        )
        .matches(regEx.lettersOnly, headers.FORMIKERRORMESSAGES.LETTERSONLY)
        .min(4, headers.FORMIKERRORMESSAGES.ATLEASTFOURCHARACTERS)
        .max(30, headers.FORMIKERRORMESSAGES.THIRTYCHARACTERSMAX),
      telephone: Yup.string()
        .required(headers.FORMIKERRORMESSAGES.REQUIRED)
        .matches(regEx.phoneRegExp, headers.FORMIKERRORMESSAGES.NUMBERSONLY)
        .min(10, headers.FORMIKERRORMESSAGES.TENDIGITSONLY)
        .max(10, headers.FORMIKERRORMESSAGES.TENDIGITSONLY),
      mobile: Yup.string()
        .required(headers.FORMIKERRORMESSAGES.REQUIRED)
        .matches(regEx.phoneRegExp, headers.FORMIKERRORMESSAGES.NUMBERSONLY)
        .min(10, headers.FORMIKERRORMESSAGES.TENDIGITSONLY)
        .max(10, headers.FORMIKERRORMESSAGES.TENDIGITSONLY),
      email: Yup.string().required(headers.FORMIKERRORMESSAGES.REQUIRED).email(headers.FORMIKERRORMESSAGES.INVALIDEMAIL),
      street: Yup.string()
        .required(headers.FORMIKERRORMESSAGES.REQUIRED)
        .matches(
          regEx.streetRegex,
          headers.FORMIKERRORMESSAGES.GREEKONLYANDFIRSTLETTERCAPITAL
        )
        .min(4, headers.FORMIKERRORMESSAGES.ATLEASTFOURCHARACTERS)
        .max(40, headers.FORMIKERRORMESSAGES.FOURTYCHARACTERSMAX),
      yearOfBirth: Yup.string().required(headers.FORMIKERRORMESSAGES.REQUIRED),
      number: Yup.string()
        .required(headers.FORMIKERRORMESSAGES.REQUIRED)
        .matches(regEx.streetNumber, headers.FORMIKERRORMESSAGES.STREETNUMBER),
      floor: Yup.number()
        .required(headers.FORMIKERRORMESSAGES.REQUIRED)
        .min(-1, headers.FORMIKERRORMESSAGES.FLOORNUMBER)
        .max(20, headers.FORMIKERRORMESSAGES.FLOORNUMBER),
      postalcode: Yup.string()
        .required(headers.FORMIKERRORMESSAGES.REQUIRED)
        .matches(regEx.numbersOnly, headers.FORMIKERRORMESSAGES.NUMBERSONLY)
        .min(5, headers.FORMIKERRORMESSAGES.POSTALCODE)
        .max(5, headers.FORMIKERRORMESSAGES.POSTALCODE),
      devices: Yup.array()
        .min(1, headers.FORMIKERRORMESSAGES.REQUIRED)
        .required(headers.FORMIKERRORMESSAGES.REQUIRED),
      area: Yup.string()
        .required(headers.FORMIKERRORMESSAGES.REQUIRED)
        .matches(
          regEx.nameRegexGreekOnly,
          headers.FORMIKERRORMESSAGES.GREEKONLYANDFIRSTLETTERCAPITAL
        )
        .min(4, headers.FORMIKERRORMESSAGES.ATLEASTFOURCHARACTERS)
        .max(40, headers.FORMIKERRORMESSAGES.FOURTYCHARACTERSMAX),
      municipalityId: Yup.number().required(
        headers.FORMIKERRORMESSAGES.REQUIRED
      ),
    }),
    onSubmit: (values) => {
      localStorage.setItem("endUserData", JSON.stringify(values));
      values.address = [
        {
          street: values.street,
          floor: values.floor,
          postalcode: values.postalcode,
          number: values.number,
          area: values.area,
          latitude: values.latitude,
          longitude: values.longitude,
          municipalityId: values.municipalityId,
        },
      ];
      values = {
        firstname: values.firstname,
        lastname: values.lastname,
        middlename: values.middlename,
        genderId: values.genderId,
        personOfContact: values.personOfContact,
        telephone: values.telephone,
        mobile: values.mobile,
        email: values.email,
        address: values.address,
        devices: values.devices,
        yearOfBirth: values.yearOfBirth,
      };
      history.push({
        pathname: "/smart-band-values",
        endUserData: values,
        selected: values.devices[0],
        locationPath: "AddEndUser",
      });
    },
  });
  useEffect(() => {
    if (localStorage.getItem("endUserData")) {
      savedData = localStorage.getItem("endUserData");
      setEndUserData(JSON.parse(savedData));
      formik.setValues(JSON.parse(savedData));
      localStorage.removeItem("endUserData");
    }
  }, [setEndUserData]);
  const clearSavedData = (name) => {
    setEndUserData((prevState) => ({ ...prevState, [name]: null }));
  };
  useEffect(() => {
    checkFormik(formik.errors, checkFormikErrors, setCheckFormikErrors);
  }, [formik.errors, checkFormikErrors]);

  const checkAddress = (municipalityId) => {
    const addressProperties = {
      street: formik.values.street,
      number: formik.values.number,
      postalcode: formik.values.postalcode,
      floor: formik.values.floor,
      area: formik.values.area,
    };
    axiosConfig
      .post(`/Address/IsAddressValid/${municipalityId}`, addressProperties)
      .then((res) => {
        formik.setFieldValue("latitude", res.data.latitude);
        formik.setFieldValue("longitude", res.data.longitude);
        setOpenMap(true);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <EndUser
      setIsValidAddress={setIsValidAddress}
  
      IsValidAddress={IsValidAddress}
      setOpenMap={setOpenMap}
      openMap={openMap}
      loading={loading}
      formik={formik}
      Devices={Devices}
      history={history}
      isEditEndUser={false}
      isAddEndUser={true}
      setCheckFormikErrors={setCheckFormikErrors}
      clearSavedData={clearSavedData}
      endUserData={endUserData}
      checkAddress={checkAddress}
      allMunicipalities={allMunicipalities}
    />
  );
}
export default AddEndUser;
